import http from './legoClient'
import api from './api'

export const getMaterialTemplateList = (from = 0, to = 8) => {
  return http.get(`/material?f=${from}&t=${to}`)
}

export const postMaterialTemplate = data => {
  return http.post('/material', data)
}

export const deleteMaterialTemplate = (id: string) => {
  return http.delete(`/material/${id}`)
}
export const updateMaterialTemplate = (id: string, data: any) => {
  return http.post(`/material/${id}`, data)
}

export const getMaterialById = (id: string) => {
  return http.get(`/material/${id}`)
}

export const uploadImage = <T extends {}>(blob, info: T) => {
  const formData = new FormData()
  Object.keys(info).forEach(key => {
    formData.append(key, info[key])
  })
  formData.append('content', blob)

  return http.post(api.uploadImg, formData)
}
